
export default () => ({
    loading: true,
    types: [],
    currentType: null
})
